import './Loader.scss';
import React from 'react';

export const Loader = () => (
  <div className="loader-container">
    <div className="lds-default">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);
